module.exports = __webpack_public_path__ + "static/img/tooltip-battery.d6012a7.png";